"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongViewingKeyError = void 0;
class WrongViewingKeyError extends Error {
    constructor(m) {
        super(m);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, WrongViewingKeyError.prototype);
    }
}
exports.WrongViewingKeyError = WrongViewingKeyError;
//# sourceMappingURL=errors.js.map